'use strict';

const React = require('react');
const PropTypes = require('prop-types');

const chatUtils = require('../../../global/utils/social/chat');

// Components
const BuyerAssuranceIcon = require('dibs-vg/dist/react/buyer-assurance');
const BuyerAssuranceTooltip = require('./BuyerAssuranceTooltip');
const Tour = require('../../../components/Tour/Tour');

const styles = require('./BuyerAssurance-style.scss');

function Tooltip(props) {
    const {hideTooltip, trackLinkClick} = props;
    const {tooltip} = props.copy;

    return <BuyerAssuranceTooltip key='pdp-buyer-assurance-tooltip' copy={tooltip} hideTooltip={hideTooltip} trackLinkClick={trackLinkClick} />;
}

Tooltip.propTypes = {
    hideTooltip: PropTypes.func,
    trackLinkClick: PropTypes.func,
    copy: PropTypes.shape({
        tooltip: PropTypes.shape({
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })
    })
};

function BuyerAssurance(props) {
    const {showTooltip, tradeTour} = props;
    const {text} = props.copy;
    const {showInfo} = props.state;

    const onClick = function (event) {
        event.preventDefault();

        if (!showInfo) {
            chatUtils.track.buyerAssuranceClick();
            showTooltip();
        }
    };

    return (
        <Tour className={styles.wrapper} dataTn="buyer-assurance-trade" step={3} {...tradeTour}>
            {/* Rendering the tooltip depending on state.showInfo */}
            {showInfo ? <Tooltip {...props} /> : null}

            {/* Rendering the icon and text */}
            <div className={styles.icon} onClick={onClick}>
                <BuyerAssuranceIcon />
            </div>
            <a href="#0" key="pdp-buyer-assurance-link" className={styles.text} onClick={onClick}>
                {text}
            </a>
        </Tour>
    );
}

BuyerAssurance.propTypes = {
    showTooltip: PropTypes.func.isRequired,
    hideTooltip: PropTypes.func,
    trackLinkClick: PropTypes.func,
    copy: PropTypes.shape({
        text: PropTypes.string.isRequired,
        tooltip: PropTypes.shape({
            title: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })
    }),
    state: PropTypes.shape({
        showInfo: PropTypes.bool.isRequired
    }),
    tradeTour: PropTypes.object
};

module.exports = BuyerAssurance;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssurance.jsx